import React, { useContext } from "react";
import PropTypes from "prop-types";
import { ProfileContext } from "Common/hooks/context/ProfileContext";
import ProfileIncompleteAlert from "./ProfileIncompleteAlert";

const ProtectedPage = ({ children, navigateTo }) => {
  const { isProfileComplete, loading } = useContext(ProfileContext);

  if (loading) return <div>Loading...</div>;

  return (
    <>
      {!isProfileComplete && <ProfileIncompleteAlert navigateTo={navigateTo} />}
      <div
        style={{
          opacity: !isProfileComplete ? 0.6 : 1,
          pointerEvents: !isProfileComplete ? "none" : "auto",
        }}
      >
        {children}
      </div>
    </>
  );
};

ProtectedPage.propTypes = {
  children: PropTypes.node.isRequired,
  navigateTo: PropTypes.string.isRequired,
};

export default ProtectedPage;
